const campaignList = {
  componentSelectors: {
    component: ".campaign-list",
    content: ".js-campaign-list",
  },

  props: {
    dynamicClass: ".c-campaign-list.dynamicLoading",
  },

  init: function () {
    bcl.u.loadStyleSheet("/etc.clientlibs/barcelo/clientlibs/clientlib-campaignList.css", this.props.dynamicClass);

    window.addEventListener("load", () => {
      const parentElement = Array.from(document.querySelectorAll(this.componentSelectors.component));
      if (parentElement) {
        parentElement.forEach((element) => {
          const content = element.querySelector(this.componentSelectors.content);

          if (content && content.classList.contains("--threeColsWithSlider")) {
            this.textHandler(content);

            let slideWithChildren = 0;

            const allSlides = content.querySelectorAll(".c-campaign-list__col-JS");
            allSlides.forEach((slide) => {
              if (slide.children.length > 0) {
                slideWithChildren++;
              }
              const card = slide.querySelector(".c-card");
              const imageOverlay = slide.querySelector(".c-card__image-overlay");
              const cardContent = slide.querySelector(".c-card__content");

              if (card && imageOverlay && cardContent) {
                card.insertBefore(imageOverlay, cardContent);
              }
            });

            if (!content.classList.contains("mod--edit")) {
              if (slideWithChildren < 2) {
                content.classList.add("mod--one-slide");
              } else {
                new window.Swiper(element.querySelector(".swiper"), {
                  spaceBetween: 24,
                  breakpoints: {
                    0: {
                      slidesPerView: 1.1,
                    },
                    425: {
                      slidesPerView: 1.5,
                    },
                    1024: {
                      slidesPerView: 2.5,
                    },
                  },
                });
              }
            }

            window.addEventListener("resize", () => {
              this.textHandler(content);
            });
          }
        });
      }
    });
  },

  textHandler: function (content) {
    const textDesktop = content.querySelectorAll(".text-desktop-JS");
    const textMobile = content.querySelectorAll(".text-mobile-JS");

    if (!bcl.u.mobile.isMobile()) {
      textDesktop.forEach((text) => {
        text.classList.remove("hidden");
      });
      textMobile.forEach((text) => {
        text.classList.add("hidden");
      });
    } else {
      textDesktop.forEach((text) => {
        text.classList.add("hidden");
      });
      textMobile.forEach((text) => {
        text.classList.remove("hidden");
      });
    }
  },
};

export default campaignList;
